import { CSSProperties, ReactNode, useEffect } from 'react';

import classNames from 'classnames';
import styled from 'styled-components';

const TabPanelStyles = styled.div`
  flex-grow: 1;
`;

type Props = {
  activePage?: string | number;
  index?: number;
  children?: ReactNode;
  value: string | number;
  title: string;
  style?: CSSProperties;
  className?: string;
  onRender?: () => void;
};

export default function TabPanel({
  activePage,
  index = 0,
  children,
  value,
  style,
  className,
  onRender
}: Props) {
  useEffect(() => {
    if (value === activePage) onRender?.();
  }, [onRender, activePage]);

  return (
    <TabPanelStyles
      hidden={value !== activePage && value !== index}
      style={style}
      className={classNames(className, 'tab-panel')}
    >
      {(value === activePage || value === index) && children}
    </TabPanelStyles>
  );
}
